module.exports = __webpack_public_path__ + "static/media/filter.b3381fa2.svg";